window.addEventListener('load',function(){
  $('.quantity-selector__wrapper').removeAttr('disabled');
})



/* ---------------------------------------------------------------------------
   Cart quantity stepper - Bolt SEO 2026-08-27

   Replaces the previous split mobile/desktop handlers with one code path.

   Previously each click fired its own request and then a full page reload, so
   rapid clicks were discarded (measured: 4 clicks -> 1 applied) and the UI felt
   dead for ~1.5s per click. On mobile the handler also used
   event.target.matches(), so taps landing on the SVG icon inside the button -
   the centre of the tap target - did nothing at all.

   Now: the number updates instantly, and the cart is synced once, after the
   user stops clicking.

   The reload is deliberately kept. Delivery tier pricing (.dl-cstm-val-cls),
   total weight and the over/under-weight state are computed by the inline
   script in layout/theme.liquid at render time, so the page has to re-render
   for them to stay correct. One reload per interaction, not one per click.
   --------------------------------------------------------------------------- */
;(function () {
  var SYNC_DELAY = 600;

  var pendingQty = {};   // line item id -> quantity
  var syncTimer = null;
  var bypassCheckoutGuard = false;

  function hasPending() {
    if (syncTimer) return true;
    for (var k in pendingQty) { if (pendingQty.hasOwnProperty(k)) return true; }
    return false;
  }

  function scheduleSync(id, qty) {
    pendingQty[id] = qty;
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(function () { flush(); }, SYNC_DELAY);
  }

  // Sends pending changes one at a time - Shopify's cart API does not tolerate
  // concurrent mutations. Reloads when done unless a callback is given.
  function flush(onDone) {
    if (syncTimer) { clearTimeout(syncTimer); syncTimer = null; }

    var batch = pendingQty;
    pendingQty = {};
    var ids = Object.keys(batch);

    if (!ids.length) {
      if (onDone) onDone();
      return;
    }

    var chain = Promise.resolve();
    ids.forEach(function (id) {
      chain = chain.then(function () {
        return fetch('/cart/change.js', {
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
          method: 'POST',
          body: JSON.stringify({ quantity: batch[id], id: id })
        }).then(function (response) { return response.json(); });
      });
    });

    chain.then(function () {
      if (onDone) { onDone(); } else { window.location.reload(); }
    }).catch(function (error) {
      // Never continue to checkout on a failed sync - the server cart would still
      // hold the old quantity while the page shows the new one. Reloading puts the
      // display back in step with the server so the shopper can retry.
      console.error('Error:', error);
      window.location.reload();
    });
  }

  function lineIdFor(input) {
    return input.id.split('updates_')[1].split(':')[0];
  }

  function inputFor(el) {
    var wrap = el.closest('.cart-item__quantity');
    return wrap ? wrap.querySelector('.quantity-selector__wrapper .quantity-selector__input') : null;
  }

  function step(button, delta) {
    var input = inputFor(button);
    if (!input) return;

    var next = parseInt(input.value, 10) + delta;
    if (isNaN(next) || next < 1) return;

    input.value = next;                                          // instant feedback
    input.dispatchEvent(new Event('change', { bubbles: true }));  // parity with the old handler
    scheduleSync(lineIdFor(input), next);
  }

  // closest(), not matches(), so a click on the SVG icon inside the button counts
  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;

    var plus = event.target.closest('.cart-item__quantity .quantity-selector__button--plus');
    if (plus) { step(plus, 1); return; }

    var minus = event.target.closest('.cart-item__quantity .quantity-selector__button--minus');
    if (minus) { step(minus, -1); }
  });

  // Never let anyone reach checkout with a quantity we haven't synced yet.
  document.addEventListener('click', function (event) {
    if (bypassCheckoutGuard) return;
    if (!event.target || !event.target.closest) return;

    var checkout = event.target.closest('[name="checkout"]');
    if (!checkout || !hasPending()) return;

    event.preventDefault();
    event.stopPropagation();
    flush(function () {
      bypassCheckoutGuard = true;
      checkout.click();
    });
  }, true);

  // Typing a quantity directly still commits on blur / Enter.
  function serverQtyOf(input) {
    return input.dataset.serverQty !== undefined ? input.dataset.serverQty : input.defaultValue;
  }

  document.querySelectorAll('.cart-item__quantity .quantity-selector__wrapper .quantity-selector__input')
    .forEach(function (input) { input.dataset.serverQty = input.value; });

  document.addEventListener('focusout', function (event) {
    if (!event.target || !event.target.closest) return;
    var input = event.target.closest('.cart-item__quantity .quantity-selector__wrapper [name="updates[]"]');
    if (!input) return;

    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 1) return;
    if (String(qty) === String(serverQtyOf(input))) return;  // nothing actually changed

    scheduleSync(lineIdFor(input), qty);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    if (!event.target || !event.target.closest) return;
    var input = event.target.closest('.cart-item__quantity .quantity-selector__wrapper [name="updates[]"]');
    if (!input) return;
    event.preventDefault();
    input.blur();   // focusout handler above does the commit
  }, true);

  // Mobile: enable the minus button once quantity is above 1 (unchanged)
  if (window.innerWidth < 750) {
    document.querySelectorAll('.cart-item__quantity').forEach(function (cartItem) {
      var inp = cartItem.querySelector('.quantity-selector__wrapper .quantity-selector__input');
      var minusWrap = cartItem.querySelector('.quantity-selector__button-wrapper--minus');
      if (inp && minusWrap && parseInt(inp.value, 10) > 1) {
        minusWrap.classList.remove('quantity-selector__button-wrapper--disabled');
      }
    });
  }
})();

/* COMPAREDER ‑ PRODUCT COMPARE APP CUSTOM JS - START */
window.ComparederModalCallback = function(eventType, processCompleted){
    if(eventType === 'open' && processCompleted === true){

        const compareMetafieldsTr = document.querySelectorAll('.pyr-compare-metafield');
        if(!compareMetafieldsTr.length)
            return false;

        compareMetafieldsTr.forEach(function(compareMetafieldTr){
            const metafield = compareMetafieldTr.metafield;
            if(metafield.namespace === 'custom' && metafield.key === 'filters-thickness'){
                var compareMetafieldsTd = compareMetafieldTr.querySelectorAll('td');
                if(compareMetafieldsTd.length){
                    if(compareMetafieldsTd[0])
                        compareMetafieldsTd[0].textContent = 'Thickness';
                }
            }
        });
    }
    return false;
};
/* COMPAREDER ‑ PRODUCT COMPARE APP CUSTOM JS - END */

// -----------------------

/* Cart quantity typing/blur is handled by the stepper block above. */


$(document).on("change", ".custom---filter-inp", function(e){
    if($(window).width() >= 860){
        $(this).closest(".custom-main-filter-form").submit();
    }
    else{
        if($(".custom---filter-inp:checked").length > 0){
            $(this).closest(".custom-main-filter-form").find(".custom-main-filter-btn").addClass("active");
            let coll = $(this).attr("data-col");
            let formData = $(this).closest(".custom-main-filter-form").serialize();
            let _url = `/collections/${coll}?${formData}`;
            let section = $(".modal--productgrid-sidebar .modal-content");
            console.log(_url);
            $.ajax({
                type: "GET",
                url: _url,
                dataType: "html",
                success: function(result){
                    let res = $(result).find(".productgrid--sidebar").html();
                    // console.log(res);
                    section.html(res);
                }
            });
        }
        else{
            $(this).closest(".custom-main-filter-form").find(".custom-main-filter-btn").removeClass("active");
            let coll = $(this).attr("data-col");
            let section = $(".modal--productgrid-sidebar .modal-content");
            $.ajax({
                type: "GET",
                url: `/collections/${coll}`,
                dataType: "html",
                success: function(result){
                    let res = $(result).find(".productgrid--sidebar").html();
                    // console.log(res);
                    section.html(res);
                }
            });
        }
    }
})
